export default __webpack_public_path__ + "static/media/logo-kemenag.30f28cfc.png";